<template>
  <div>
    <div class="tab-pane pt-3 active show" v-if="ready">
      <div id="formArea">
        <div class="row">
          <div class="col-12">
            <h4>修改商品設定</h4>
            <form class="form">
              <div class="panel panel-form searchArea">
                <h4 class="text-green text-center">搜尋條件</h4>
                <!-- 公司別 -->
                <div class="form-group row">
                  <label class="col-2 text-right"><span class="text-red">＊</span>公司別</label>
                  <div class="col-9">
                    <select
                      class="form-control form-control-inline form-wide"
                      v-model="searchData.company"
                      @change="onChangeSearchData"
                      >
                      <option
                        v-for="(item, index) in options.companies"
                        :key="index"
                        :value="item"
                        >
                        {{ item.COMPSNM }}
                      </option>
                    </select>
                  </div>
                </div>
                <!-- 商品種類 -->
                <div class="form-group row">
                  <label class="col-2 text-right"><span class="text-red">＊</span>商品種類</label>
                  <div class="col-9">
                    <select
                      v-if="searchData.company.COMPANYID == '2564c669825f4409b9b1908819514c0a'"
                      class="form-control form-control-inline form-wide"
                      v-model="searchData.productType"
                      @change="onChangeSearchData"
                      >
                      <option
                        v-for="(item, index) in options.productType"
                        :key="index"
                        :value="item.value"
                        >
                        {{ item.name }}
                      </option>
                    </select>
                    <select
                      v-else
                      class="form-control form-control-inline form-wide"
                      v-model="searchData.productType"
                      @change="onChangeSearchData"
                      >
                      <option
                        v-for="(item, index) in options.productType.slice(0,4)"
                        :key="index"
                        :value="item.value"
                        >
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <!-- 險種種類 -->
                <div class="form-group row">
                  <label class="col-2 text-right"><span class="text-red">＊</span>險種種類</label>
                  <div class="col-9">
                    <select
                      class="form-control form-control-inline form-wide"
                      v-model="searchData.contractType"
                      @change="onChangeSearchData"
                      >
                      <option
                        v-for="(item, index) in options.contractType"
                        :key="index"
                        :value="item.value"
                        >
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <!-- 商品名稱 -->
                <div class="form-group row">
                  <label class="col-2 text-right">商品名稱</label>
                  <div class="col-7">
                    <div style="margin: 0 5px">
                      <v-select
                        v-if="options.insuranceTypes.length"
                        v-model="searchData.productId"
                        :options="options.insuranceTypes"
                        :reduce="(item) => item.productid"
                        label="name"
                        :placeholder="searchData.productPlaceholder ? searchData.productPlaceholder:'請選擇或輸入'"
                        ref="selectInsurance"
                        >
                        <div slot="no-options">沒有資料可供選擇 !</div>
                      </v-select>
                      <v-select
                        v-else-if="isInsuranceTypesLoading"
                        placeholder="讀取中..."
                        disabled
                        ></v-select>
                      <v-select
                        v-else
                        :placeholder="!searchData.company ? '請先選擇公司別':'沒有資料可供選擇 !'"
                        disabled
                        ></v-select>
                    </div>
                  </div>
                </div>
              </div>
            </form>
            <form class="form mt-50" v-if="searchData.productId" :class="{'section-loading': isFormLoading}">
              <div class="panel panel-form bg-white">
                <h4 class="text-center">搜尋結果</h4>
                <!-- 公司別 -->
                <div class="form-group row">
                  <label class="col-2 text-right">公司別</label>
                  <div class="col-9">
                    <span class="lh-40">{{ formData.company.COMPSNM }}</span>
                  </div>
                </div>
                <!-- 險種名稱 -->
                <div class="form-group row">
                  <label class="col-2 text-right"><span class="text-red">＊</span>險種名稱</label>
                  <div class="col-9">
                    <input
                      type="text"
                      maxlength="40"
                      placeholder="險種名稱"
                      class="form-control form-control-inline"
                      :class="{ 'is-invalid': errors.has('insuranceName')}"
                      data-vv-as="險種名稱"
                      :data-vv-name="'insuranceName'"
                      v-validate="'required'"
                      v-model="formData.insuranceName"
                      @input="formData.insuranceName = formData.insuranceName.trim()"
                      @blur="formData.insuranceName = formData.insuranceName.trim()"
                      />
                  </div>
                </div>
                <!-- 險種代碼 -->
                <div class="form-group row">
                  <label class="col-2 text-right">險種代碼</label>
                  <div class="col-9">
                    <input
                      type="text"
                      placeholder="險種代碼"
                      maxlength="20"
                      class="form-control form-control-inline"
                      v-model="formData.insuranceCode"
                      @input="formData.insuranceCode = formData.insuranceCode.replace(/\s+/g, '')"
                      @blur="formData.insuranceCode = formData.insuranceCode.replace(/\s+/g, '')"
                      />
                  </div>
                </div>
                <!-- 商品種類 -->
                <div class="form-group row">
                  <label class="col-2 text-right"><span class="text-red">＊</span>商品種類</label>
                  <div class="col-9">
                    <select
                      v-if="formData.company.COMPANYID == '2564c669825f4409b9b1908819514c0a'"
                      class="form-control form-control-inline form-wide"
                      v-model="formData.productType"
                      >
                      <option
                        v-for="(item, index) in options.productType"
                        :key="index"
                        :value="item.value"
                        >
                        {{ item.name }}
                      </option>
                    </select>
                    <select
                      v-else
                      class="form-control form-control-inline form-wide"
                      v-model="formData.productType"
                      >
                      <option
                        v-for="(item, index) in options.productType.slice(0,4)"
                        :key="index"
                        :value="item.value"
                        >
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <!-- 險種種類 -->
                <div class="form-group row">
                  <label class="col-2 text-right">險種種類</label>
                  <div class="col-9">
                    <div class="col-9">
                      <span class="lh-40">{{ options.contractType.filter((x) => x.value == formData.contractType)[0].name }}</span>
                    </div>
                  </div>
                </div>
                <!-- 預定利率 -->
                <div class="form-group row" v-if="formData.productType!='3'">
                  <label class="col-2 text-right"><span class="text-red">＊</span>預定利率</label>
                  <div class="col-9">
                    <!-- 0到3.25:間距為0.05；3.25~10:間距為0.25 -->
                    <select
                      class="form-control form-control-inline form-wide"
                      v-model="formData.rate"
                      >
                        <option 
                          v-for="(rateOpt, index) in rateOptList" 
                          :key="index" 
                          :value="rateOpt.optVal"
                          >
                          {{ rateOpt.optKey }}
                        </option>
                    </select>
                  </div>
                </div>
                <!-- 幣別 -->
                <div class="form-group row">
                  <label class="col-2 text-right"><span class="text-red">＊</span>幣別</label>
                  <div class="col-9">
                    <select
                      class="form-control form-control-inline form-wide"
                      v-model="formData.currency"
                      >
                      <option
                        v-for="(item, index) in options.currency"
                        :key="index"
                        :value="item.value"
                        >
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <!-- 繳費年期 -->
                <div class="form-group row">
                  <label class="col-2 text-right"><span class="text-red">＊</span>繳費年期</label>
                  <div class="col-9" :class="{'payPriodError' : isPayPriodEmpty}">
                    <label class="col-2 text-right mr-8">定期型:</label>
                    <div class="checkbox radio-inline" v-for="(item, i) in formData.regularType" :key="`regularType-item-${i}`">
                      <input class="w-50" type="checkbox" :id="`regularType-${i}`" v-model="formData.regularType[i].check">
                      <label class="w-50" :for="`regularType-${i}`">{{item.year}}</label>
                    </div>
                    <br/>
                    <br/>
                    <label class="col-2 text-right mr-8">歲滿型:</label>
                    <div class="checkbox radio-inline" v-for="(item, i) in formData.maturityType" :key="`maturityType-item-${i}`">
                      <input class="w-50" type="checkbox" :id="`maturityType-${i}`" v-model="formData.maturityType[i].check">
                      <label class="w-50" :for="`maturityType-${i}`">{{item.year}}</label>
                    </div>
                  </div>
                </div>
                <!-- 保障終期 -->
                <div class="form-group row">
                  <label class="col-2 text-right"><span class="text-red">＊</span>保障終期</label>
                  <div class="col-9">
                    <input
                      type="number"
                      class="form-control form-control-inline w-70"
                      :class="{ 'is-invalid': errors.has('endYear')}"
                      data-vv-as="保障終期"
                      :data-vv-name="'endYear'"
                      v-validate="'required'"
                      v-model="formData.endYear"
                      @input="checkEndYear"
                      @blur="checkEndYear"
                      />
                    <span class="lh-50">歲</span>
                    <br/>
                    <span>若為定期險且保障也是定期時，保障終期請設定大於100，ex:繳費年期20年，保障也只有20年期</span>
                    <br/>
                    <span>若為定期險且保障至一個歲數或終身時，請設定小於100，ex:繳費年期20年，保障至75歲</span>
                    <br/>
                  </div>
                </div>
                <!-- 續保設定 -->
                <div class="form-group row" v-if="formData.productType!='3'">
                  <label class="col-2 text-right"><span v-if="!isInvestType" class="text-red">＊</span>續保設定</label>
                  <div class="col-9">
                    <span class="lh-50">本人續保</span>
                    <input
                      type="number"
                      class="form-control form-control-inline w-70"
                      :class="{ 'is-invalid': errors.has('selfRenewal')}"
                      data-vv-as="本人續保"
                      :data-vv-name="'selfRenewal'"
                      v-validate="{required:!isInvestType}"
                      v-model="formData.selfRenewal"
                      @input="checkSelfRenewal"
                      @blur="checkSelfRenewal"
                      />
                    <span class="lh-50">歲數，配偶續保</span>
                    <input
                      type="number"
                      class="form-control form-control-inline w-70"
                      :class="{ 'is-invalid': errors.has('spouseRenewal')}"
                      data-vv-as="配偶續保"
                      :data-vv-name="'spouseRenewal'"
                      v-validate="{required:!isInvestType}"
                      v-model="formData.spouseRenewal"
                      @input="checkSpouseRenewal"
                      @blur="checkSpouseRenewal"
                      />
                    <span class="lh-50">歲數，子女續保</span>
                    <input
                      type="number"
                      class="form-control form-control-inline w-70"
                      :class="{ 'is-invalid': errors.has('childRenewal')}"
                      data-vv-as="子女續保"
                      :data-vv-name="'childRenewal'"
                      v-validate="{required:!isInvestType}"
                      v-model="formData.childRenewal"
                      @input="checkChildRenewal"
                      @blur="checkChildRenewal"
                      />
                    <span class="lh-50">歲數</span>
                  </div>
                </div>
                <!-- 保障年期類型 -->
                <div class="form-group row">
                  <label class="col-2 text-right"><span class="text-red">＊</span>保障年期類型</label>
                  <div class="radio radio-inline ml-15">
                    <input type="radio" id="yearType-1" v-model="formData.yearType" value="1">
                    <label for="yearType-1">終身</label>
                  </div>
                  <div class="radio radio-inline">
                    <input type="radio" id="yearType-2" v-model="formData.yearType" value="2">
                    <label for="yearType-2">定期</label>
                  </div>
                  <div class="radio radio-inline">
                    <input type="radio" id="yearType-3" v-model="formData.yearType" value="3">
                    <label for="yearType-3">一年期</label>
                  </div>
                </div>
                <!-- 單位 -->
                <div class="form-group row">
                  <label class="col-2 text-right"><span class="text-red">＊</span>單位</label>
                  <div class="col-5">
                    <div class="radio radio-inline ml-5">
                      <input type="radio" id="unit-1" v-model="formData.unit" value="1">
                      <label for="unit-1">元</label>
                    </div>
                    <div class="radio radio-inline">
                      <input type="radio" id="unit-2" v-model="formData.unit" value="2">
                      <label for="unit-2">萬</label>
                    </div>
                    <div class="radio radio-inline" v-if="formData.productType!='3'">
                      <input type="radio" id="unit-3" v-model="formData.unit" value="3">
                      <label for="unit-3">單位</label>
                    </div>
                    <div class="radio radio-inline" v-if="formData.productType!='3'">
                      <input type="radio" id="unit-4" v-model="formData.unit" value="0">
                      <label for="unit-4">計畫</label>
                    </div>
                  </div>
                  <div class="col-5" v-if="formData.unit == '3'">
                    <label class="text-right lh-40">保額</label>
                    <input
                      type="number"
                      placeholder="保額"
                      :class="{'is-invalid': isUnitPriceEmpty}"
                      class="form-control form-control-inline w-120"
                      v-model="formData.unitPrice"
                      @input="checkUnitPrice"
                      @blur="checkUnitPrice"
                      />
                    <label class="text-right  lh-40">元</label>
                  </div>
                </div>
                <!-- 計畫別 -->
                <div class="form-group row" v-if="formData.unit == '0'">
                  <label class="col-2 text-right"><span class="text-red">＊</span>計畫</label>
                  <div class="schemeArea">
                    <div>
                      <input
                        type="text"
                        maxlength="25"
                        placeholder="計畫別名稱"
                        :class="{'is-invalid': isSchemeNameEmpty}"
                        class="form-control form-control-inline w-120"
                        v-model="formData.schemeName"
                        @input="formData.schemeName = formData.schemeName.trim()"
                        @blur="formData.schemeName = formData.schemeName.trim()"
                        />
                      <span class="lh-50">:</span>
                      <select
                        class="form-control form-control-inline form-wide w-130"
                        v-model="formData.schemeQuotaType"
                        >
                        <option value="0">日額</option>
                        <option value="1">日額(不顯示)</option>
                      </select>
                      <input
                        type="number"
                        :class="{'is-invalid': isSchemeQuotaDollorEmpty}"
                        class="form-control form-control-inline w-120"
                        placeholder="金額"
                        v-model="formData.schemeQuotaDollor"
                        @input="checkSchemeQuotaDollor"
                        @blur="checkSchemeQuotaDollor"
                        />
                      <span class="lh-50">元</span>
                      <button type="button" class="btn btn-default btn-sm ml-50" :style="{ visibility: isSchemeEdit ? 'hidden' : 'visible' }" @click="checkAndInsertScheme">新增</button>
                    </div>
                    <section class="schemeTable" v-if="!!formData.productId" :class="{'section-loading': isSchemeTableLoading}">
                      <table class="table datatable">
                        <thead>
                          <tr>
                            <th style="width:20%;"></th>
                            <th style="width:20%;"></th>
                            <th style="width:30%;">計畫</th>
                            <th style="width:30%;">日額/限額</th>
                          </tr>
                        </thead>
                        <tbody v-if="schemeData.length">
                          <tr v-for="(data, i) in schemeData" :key="`schemeData-data-${i}`">
                            <td>
                              <button
                                type="button"
                                class="btn btn-primary btn-sm"
                                v-if="data.editMode"
                                @click="updateSchemeData(data)"
                                >
                              更新
                              </button>
                              <button
                                type="button"
                                class="btn btn-primary btn-sm"
                                :disabled="isSchemeEdit"
                                v-else
                                @click="doSchemeEdit(data)"
                                >
                              編輯
                              </button>
                            </td>
                            <td>
                              <button
                                type="button"
                                class="btn btn-default btn-sm"
                                v-if="data.editMode"
                                @click="cancelSchemeEdit(data)"
                                >
                              取消
                              </button>
                              <button
                                type="button"
                                class="btn btn-default btn-sm"
                                :disabled="isSchemeEdit"
                                v-else
                                @click="deleteSchemeData(data)"
                                >
                              刪除
                              </button>
                            </td>
                            <td>{{data.name}}</td>
                            <td v-if="data.editMode">                        
                              <input
                                type="number"
                                :class="{'is-invalid': isSchemeEditQuotaDollorEmpty}"
                                class="form-control form-control-inline w-120"
                                placeholder="日額金額"
                                @input="checkSchemeEditQuotaDollor"
                                @blur="checkSchemeEditQuotaDollor"
                                v-model="schemeEditQuotaDollor"
                                />
                            </td>
                            <td v-else>{{data.quantity + "元"}}</td>
                          </tr>
                        </tbody>
                        <tbody v-else>
                          <tr>
                            <td class="text-center" colspan="4">
                              <h4 class="mb-3">查無資料</h4>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </section>
                  </div>
                </div>
                <!-- 繳別 -->
                <div class="form-group row" v-if="formData.productType!='3'">
                  <label class="col-2 text-right"><span class="text-red">＊</span>繳別</label>
                  <div class="col-9" :class="{'payPriodError' : isPaymentWayEmpty}">
                    <div class="checkbox radio-inline ml-5" v-for="(item, i) in paymentWay" :key="`paymentWay-item-${i}`">
                      <input 
                        type="checkbox" 
                        :id="`paymentWay-item-${i}`" 
                        v-model="paymentWay[i].check"
                        @change="checkPaymentWay"
                      >
                      <label :for="`paymentWay-item-${i}`">{{item.name}}</label>
                    </div>
                  </div>
                </div>
                <!-- 銷售狀態 -->
                <div class="form-group row">
                  <label class="col-2 text-right"><span class="text-red">＊</span>銷售狀態</label>
                  <div class="col-9">
                    <div class="radio radio-inline ml-5">
                      <input type="radio" id="sellStatus-1" v-model="formData.sellStatus" value="1">
                      <label for="sellStatus-1">開辦</label>
                    </div>
                    <div class="radio radio-inline">
                      <input type="radio" id="sellStatus-2" v-model="formData.sellStatus" value="2">
                      <label for="sellStatus-2">停售</label>
                    </div>
                    <br/>
                    <div class="checkbox radio-inline ml-5">
                      <input type="checkbox" id="excludeTeenager-checkbox" v-model="formData.excludeTeenager">
                      <label for="excludeTeenager-checkbox">排除15歲以下年齡的保障 (保險法107條)</label>
                    </div>
                  </div>
                </div>
                <!-- 非平準商品 -->
                <div class="form-group row">
                  <label class="col-2 text-right"> 非平準商品</label>
                  <div class="col-9">
                    <span class="lh-40">{{ formData.level_prem_ind }}</span>
                  </div>
                </div>
                <!-- 商品流水號 -->
                <div class="form-group row">
                  <label class="col-2 text-right"> 商品流水號</label>
                  <div class="col-9">
                    <span class="lh-40">{{ formData.pln }}</span>
                  </div>
                </div>
                <div class="action mt-2 text-left">
                  <button
                  type="button"
                    class="btn btn-default"
                    @click="checkProductDeletable()"
                    >
                  刪除
                  </button>
                  <button
                    type="button"
                    class="btn btn-default"
                    style="margin-left:80px"
                    @click="formulaMantain()"
                    >
                  公式維護
                  </button>
                  <button
                    type="button"
                    class="btn btn-default"
                    @click="formulaEstimate()"
                    >
                    試算公式
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary"
                    :disabled="isSavingButton"
                    @click="updateTempSavedInsuranceProduct(1)"
                    >
                  存檔
                  </button>
                  <button
                  type="button"
                  class="btn btn-primary"
                  :disabled="isCheckButton"
                  @click="updateTempSavedInsuranceProduct(2)"
                  >
                  覆核
                </button>
                <button
                  v-if="formData.productType != 5"
                  type="button"
                  class="btn btn-primary"
                  :disabled="isReleaseInformation"
                  @click="updateTempSavedInsuranceProduct(3)"
                  >
                發佈產品資訊
                </button>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="text-center">
          <transition name="bottom_fade">
            <section id="copyArea" v-show="!isScroll" class="search container fixed_bottom">
              <div>
                <!-- 公司別 -->
                <div class="d-inline-flex">
                  <span class="text-right lh-40 ml-5 mr-5">複製此商品至:</span>
                  <select
                    class="form-control form-control-inline form-wide"
                    v-model="copyData.company"
                    >
                    <option :value="{}">請選擇</option>
                    <option
                      v-for="(item, index) in options.companies"
                      :key="index"
                      :value="item"
                      >
                      {{ item.COMPSNM }}
                    </option>
                  </select>
                <!-- 商品種類 -->
                  <select
                    class="form-control form-control-inline form-wide"
                    v-model="copyData.productType"
                    >
                    <option value>請選擇</option>
                    <option
                      v-for="(item, index) in options.productType"
                      :key="index"
                      :value="item.value"
                      >
                      {{ item.name }}
                    </option>
                  </select>
                </div>
                <!-- 新險種名稱 -->
                <div class="d-inline-flex">
                  <span class="text-right lh-40 ml-5 mr-5">新險種名稱:</span>
                  <input
                    type="text"
                    maxlength="40"
                    class="form-control form-control-inline"
                    v-model="copyData.insuranceName"
                    />
                </div>
                <!-- 新險種代號 -->
                <div class="d-inline-flex">
                  <span class="text-right lh-40 ml-5 mr-5">新險種代號(不要重複使用):</span>
                  <input
                    type="text"
                    maxlength="10"
                    class="form-control form-control-inline"
                    v-model="copyData.insuranceCode"
                    />
                </div>
                <div class="checkbox radio-inline ml-15 mb-15">
                  <input type="checkbox" id="isCopyFomular" v-model="copyData.isCopyFomular">
                  <label for="isCopyFomular" class="lh-40">複製報表公式</label>
                </div>
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="copy()"
                  >
                開始複製(未發佈)
                </button>
              </div>
            </section>
          </transition>
        </div>
      </div>
    </div>
    <div v-else>
      <message
        class="mt-5 d-flex justify-content-center"
        loading
        message="資料讀取中，請稍候..."
        />
    </div>
    <mv-mask :open="mvMaskOpen" :content="mvMaskContent" />
  </div>
</template>

<script>
import Message from "@/desktop/components/Message.vue";
import MvMask from "@/desktop/views/mv/components/mvMask";
import ThisMixin from "./InsuranceProduct";
import {
  querySavedProduct,
  getSavedProductDetail,
  updateTempSavedInsuranceProduct,
  deleteTempSavedInsuranceProduct,
  copyInsuranceProduct,
  getIsProductDeletable,
} from "@/service";
export default {
  name: "InsuranceProductEdit",
  components: {
    Message,
    MvMask,
  },
  mixins: [ThisMixin],
  computed: {
    ready() {
      return !window._.isEmpty(this.options.companies);
    },
  },
  props: {
    editProduct: {
      type: Object,
      default: () => {
        return null;
      },
    },
  },
  watch: {
    "searchData.productId": async function() {
      if (this.searchData.productId) {
        this.isFormLoading = true;
        await this.getYearPeriodOption();
        await this.getSavedProductDetail();
        this.isFormLoading = false;
      } else {
        this.$refs["selectInsurance"].clearSelection();
      }

      if (
        this.editProduct &&
        this.editProduct.productid != this.searchData.productId
      ) {
        this.searchData.productPlaceholder = "";
      }
    },
    schemeData: function(data) {
      this.formData.schemeData = data;
    }
  },
  data() {
    return {
      idx:"",
      tempUser: "",
      saveUser: "",
      isSavingButton: true, //存檔(按鈕停用)
      isReleaseInformation: true, //發佈產品資訊(按鈕停用)
      isCheckButton: true, //覆核(按鈕停用)
      isScroll: false,
      isInsuranceTypesLoading: false,
      isFormLoading: false,
      deletable: null, // 刪除按鈕功能 true:確認刪除彈窗 false:警告無法刪除彈窗
      searchData: {
        company: {},
        productType: "1", //商品種類
        contractType: "1", //險種種類
        productId: "", //險種ID
        productPlaceholder: "", //商品名稱placeholder
      },
      copyData: {
        company: {},
        productType: "",
        insuranceName: "",
        insuranceCode: "",
        isCopyFomular: false,
      },
      processStatus: "", //商品處理狀態 0:暫存 1:存檔 2:覆核 3:發佈
      action: { 1: "存檔", 2: "覆核", 3: "發佈" },
      rateOptList: [],
      mvMaskContent: "",
      mvMaskOpen: false,
      isPaymentWayEmpty: false,
    };
  },
  methods: {
    async init() {
      localStorage.productData = "";
      await this.getCompaniesOption();
      if (this.editProduct) {
        this.searchData.company = this.options.companies.filter(
          (x) => x.COMPANYID == this.editProduct.companyid
        )[0];
        this.searchData.contractType = this.editProduct.contracttype;
        this.searchData.productType = this.editProduct.producttype;
        this.searchData.productId = this.editProduct.productid;
        this.searchData.productPlaceholder =
          this.editProduct.name + this.editProduct.plan_code;
      } else {
        this.searchData.company = this.options.companies[0];
      }
      await this.getRateOpts();
      await this.doSearch();
    },
    async doSearch() {
      this.options.insuranceTypes = [];
      this.isInsuranceTypesLoading = true;
      let reqData = {
        companyid: this.searchData.company.COMPANYID,
        producttype: this.searchData.productType,
        contracttype: this.searchData.contractType,
      };
      await querySavedProduct(this.$store.state.userInfo.id, reqData).then(
        (result) => {
          if (result.header && result.header.status == "200") {
            this.options.insuranceTypes = result.data.map((item) => ({
              productid: item.productid,
              name: item.name + item.plan_code,
            }));
          }
          this.isInsuranceTypesLoading = false;
        }
      );
    },
    async getSavedProductDetail() {
      await getSavedProductDetail(
        this.$store.state.userInfo.id,
        this.searchData.productId
      ).then((result) => {
        if (result.header && result.header.status == "200") {
          this.setUpFormData(result.data);
        } else {
          this.$toast.info({ title: result.header.message });
        }
      });
    },
    setUpFormData(res) {
      this.isPaymentWayEmpty = false; 
      this.deletable = null;
      this.idx = res.idx;
      this.tempUser = res.tempuser;
      this.saveUser = res.saveuser;
      this.processStatus = res.process_status;
      if(res.level_prem_ind == '0') {
        this.formData.level_prem_ind = '是'
      } else if (res.level_prem_ind == '1') {
        this.formData.level_prem_ind = '否'
      } else {
        this.formData.level_prem_ind = '無法判斷'
      }
      this.formData.pln = res.pln;
      this.formData.company = this.options.companies.filter(
        (x) => x.COMPANYID == res.companyid
      )[0];
      this.formData.productId = res.productid;
      this.formData.insuranceName = res.name;
      this.formData.insuranceCode = res.plan_code;
      this.formData.productType = res.producttype;
      this.formData.contractType = res.contracttype;
      this.formData.yearType = res.coverageyearperiodtype;
      this.formData.unit = res.unit;
      this.formData.schemeName = "";
      this.formData.schemeQuotaType = "0";
      this.formData.schemeQuotaDollor = "";
      this.formData.sellStatus = res.status;
      this.formData.rate = res.asirt;
      this.formData.currency = res.currencytype;
      this.formData.endYear = res.coverageend;
      this.formData.selfRenewal = res.hage;
      this.formData.spouseRenewal = res.phage;
      this.formData.childRenewal = res.chage;
      this.formData.unitPrice = res.unitprice;
      this.formData.ageperiods = res.ageperiods;
      this.formData.terminableperiods = res.terminableperiods;
      this.formData.excludeTeenager = res.exclude_15 == "1" ? true : false;
      this.formData.regularType = this.formData.regularType.map(
        ({ year, type }) => ({
          year,
          type,
          check: res.terminableperiods
            ? res.terminableperiods
                .split(",")
                .includes(parseInt(year.replaceAll(/\s+/g, "")).toString())
            : false,
        })
      );
      this.formData.maturityType = this.formData.maturityType.map(
        ({ year, type }) => ({
          year,
          type,
          check: res.ageperiods
            ? res.ageperiods
                .split(",")
                .includes(parseInt(year.replaceAll(/@\s+/g, "")).toString())
            : false,
        })
      );
      this.paymentWay = this.paymentWay.map(({ name, value }) => ({
        name,
        value,
        check: res.paymentwaylist
          ? res.paymentwaylist.split(",").includes(value)
          : false,
      }));

      this.copyData.company = this.formData.company;
      this.copyData.productType = this.formData.productType;
      this.copyData.insuranceName = "";
      this.copyData.insuranceCode = "";
      this.copyData.isCopyFomular = false;

      if (this.formData.productId) {
        this.isSavingButton = false;
        this.isReleaseInformation = false;
        this.isCheckButton = false;
      }

      if (!this.processStatus) {
        this.isReleaseInformation = true;
        this.isCheckButton = true;
      } else if (this.processStatus == "0") {
        this.isReleaseInformation = true;
        this.isCheckButton = true;
        if(this.tempUser != this.$store.state.userInfo.id) {
          this.isSavingButton = true;
        }
      } else if (this.processStatus == "1") {
        this.isReleaseInformation = true;
        if (this.saveUser == this.$store.state.userInfo.id) {
            this.isCheckButton = true;
        }

        if (this.saveUser != this.$store.state.userInfo.id) {
            this.isSavingButton = true;
        }
      } else if (this.processStatus == "2") {
        this.isSavingButton = true;
        this.isReleaseInformation = false;
        this.isCheckButton = true;
      } else if (this.processStatus == "3") {
        this.isCheckButton = true;
      }

      if (this.formData.unit == "0") {
        this.querySchemeData();
      }

    },
    checkAndInsertScheme() {
      // 檢查是否有輸入值 
      if (!this.formData.schemeName || !this.formData.schemeQuotaDollor) {
        this.isSchemeNameEmpty = !this.formData.schemeName;
        this.isSchemeQuotaDollorEmpty = !this.formData.schemeQuotaDollor;
        return;
      }
      const isDuplicate = this.schemeData.some(
        (data) => 
          data.name === this.formData.schemeName.trim() && 
          String(data.quantity) === String(this.formData.schemeQuotaDollor)
      );

      if (isDuplicate) {
        this.$toast.info({ title: "相同計畫別已存在，如欲調整內容，請先刪除再新增" });
        return;
      }
      this.insertSchemeData(); 
    },

    checkPaymentWay() {
      const hasChecked = this.paymentWay.some(item => item.check);
      if (hasChecked) {
        this.isPaymentWayEmpty = false;
      }
    },    
    async updateTempSavedInsuranceProduct(action) {
      if (this.formData.productType !== '3') {
        const hasPaymentSelected = this.paymentWay.some(item => item.check);
        if (!hasPaymentSelected) {
          this.isPaymentWayEmpty = true; 
          this.$toast.info({ title: "商品需設定至少一組繳別" });
          return; 
        }
      }      
      if (await this.validateAll()) {
        return;
      }
      if (action == "1" && ((this.processStatus == "0" && this.tempUser != this.$store.state.userInfo.id) || (this.processStatus == "1" && this.saveUser != this.$store.state.userInfo.id))) {
        this.$toast.info({ title: "此商品已被其他人鎖定編輯中" });
        return;
      } else if (action == "2" && this.saveUser == this.$store.state.userInfo.id) {
        this.$toast.info({ title: "你不能覆核自己存檔的商品" });
        return;
      }
      let reqData;
      //action(執行動作) 1:存檔 2:覆核 3:發佈
      if (action < 2) {
        reqData = this.getReqData(action);
        Object.defineProperty(reqData,'idx',{
            value : this.idx,
            writable : true,
            enumerable : true,
            configurable : true
        })
      } else {
        reqData = {
          productid: this.formData.productId,
          action: action,
          userId: this.$store.state.userInfo.mainUserId ? this.$store.state.userInfo.mainUserId : this.$store.state.userInfo.id,
          userName: this.$store.state.userInfo.mainUserId ? "" : this.$store.state.userInfo.name,
          idx: this.idx,
          compnm: this.formData.company.COMPSNM,
          name: this.formData.insuranceName,
          plan_code: this.formData.insuranceCode,
          money:this.formData.currency,
        };
      }
      updateTempSavedInsuranceProduct(
        this.$store.state.userInfo.id,
        reqData
      ).then((result) => {
        if (result.header && result.header.status == "200") {
          this.$toast.info({ title: this.action[action] + "成功" });
          this.$emit("close");
        } else {
          this.$toast.info({ title: result.header.message });
        }
      });
    },
    checkProductDeletable() {
      if (this.deletable == null) {
        getIsProductDeletable(
          this.$store.state.userInfo.id,
          this.formData.productId
        ).then((result) => {
          if (result.header && result.header.status == "200") {
            this.deletable = result.data.deletable;
            this.deleteTempSavedInsuranceProduct();
          } else {
            this.$toast.info({ title: result.header.message });
          }
        })
      } else {
        this.deleteTempSavedInsuranceProduct();
      }
    },
    deleteTempSavedInsuranceProduct() {
      if (this.deletable && confirm("刪除後無法復原，請確認是否需要刪除")) {
        deleteTempSavedInsuranceProduct(
          this.$store.state.userInfo.id,
          this.formData.productId
        ).then((result) => {
          if (result.header && result.header.status == "200") {
            this.$toast.info({ title: "刪除成功" });
            this.$emit("close");
          } else {
            this.$toast.info({ title: result.header.message });
          }
        });
      } else if (!this.deletable)  {
        alert("該檔商品已有同業保單輸入，無法刪除");
      }
    },
    formulaMantain() {
      localStorage.productData = JSON.stringify(this.formData);
      localStorage.editProduct = JSON.stringify(this.editProduct);
      if (
        this.searchData.productType == "1" ||
        this.searchData.productType == "4" ||
        this.searchData.productType == "5"
      ) {
        this.$router.push({ name: "CoverageFormulaSummary" }); //公式維護(傳統型、傳統型取大)
      } else if (
        this.searchData.productType == "2" ||
        this.searchData.productType == "3"
      ) {
        this.$router.push({ name: "InvestFormula" }); //公式維護(投資型、利率變動型)
      }
    },
    formulaEstimate() {
      localStorage.productData = JSON.stringify(this.formData);
      localStorage.editProduct = JSON.stringify(this.editProduct);
      if (
        this.searchData.productType == "1" ||
        this.searchData.productType == "4" ||
        this.searchData.productType == "5"
      ) {
        this.$router.push({ name: "CoverageFormulaValidation" }); //試算公式(傳統型、傳統型取大)
      } else if (
        this.searchData.productType == "2" ||
        this.searchData.productType == "3"
      ) {
        this.$router.push({ name: "InvestCoverageFormulaValidation" }); //試算公式(投資型、利率變動型)
      }
    },
    onChangeSearchData() {
      this.searchData.productId = "";
      this.resetCopyData();
      this.doSearch();
    },
    resetCopyData() {
      this.copyData = {
        company: this.options.companies[0],
        productType: "1",
        insuranceName: "",
        insuranceCode: "",
        isCopyFomular: false,
      };
    },
    copy() {
      this.mvMaskContent = "複製商品中，請稍候...";
      this.panelOpen("mvMaskOpen");
      const req = this.copyData;
      req.productId = this.formData.productId;
      req.companyId = this.copyData.company.COMPANYID;
      req.userId = this.$store.state.userInfo.id;
      copyInsuranceProduct(req).then(async (result) => {
        if (result.header && result.header.status == "200") {
          this.searchData.company = this.copyData.company;
          this.searchData.productType = this.copyData.productType;
          await this.doSearch();
          this.searchData.productId = result.data.productid;
        } else {
          this.$toast.info({ title: result.header.message });
        }
        this.panelClose("mvMaskOpen");
      });
    },
    scrollEvent() {
      // ----滾動顯示/隱藏----
      this.isScroll = true;
      clearTimeout(this.scrolltimeOutProcessId);
      this.scrolltimeOutProcessId = setTimeout(() => {
        this.isScroll = false;
        //調整底部padding，避免被蓋住
        window
          .$("#formArea")
          .css("padding-bottom", window.$("#copyArea").height() + 10 + "px");
      }, 500);
    },
    //預定利率選單項目
    getRateOpts() {
      //0到3.2:間距為0.05
      for (let i = 0; i <= 3.2; i = i + 0.05) {
        this.rateOptList.push({
          optVal: parseFloat((i / 100).toFixed(4)),
          optKey: i.toFixed(2),
        });
      }
      //3.25~10:間距為0.25(半碼)
      for (let i = 3.25; i <= 10; i = i + 0.25) {
        this.rateOptList.push({
          optVal: parseFloat((i / 100).toFixed(4)),
          optKey: i.toFixed(2),
        });
      }
    },
  },
  created() {
    window.addEventListener("scroll", () => {
      this.scrollEvent();
    });
  },
  mounted() {
    this.init();
  },
};
</script>
<style lang="scss" scoped>
* {
  user-select: text;
}
.mt-50 {
  margin-top: 50px;
}
.ml-15 {
  margin-left: 15px !important;
}
.ml-5 {
  margin-left: 5px !important;
}
.ml-50 {
  margin-left: 50px !important;
}
.mb-15 {
  margin-bottom: 15px !important;
}
.mr-5 {
  margin-right: 5px !important;
}
.mr-8 {
  margin-right: 8px;
}
.lh-40 {
  line-height: 40px;
}
.lh-50 {
  line-height: 50px;
}
.w-50 {
  width: 50px !important;
}
.w-70 {
  width: 70px !important;
}
.w-120 {
  width: 120px !important;
}
.w-130 {
  width: 130px !important;
}
.w-150 {
  width: 150px !important;
}
.searchArea {
  border-color: #027a39;
  border-width: 3px;
  background-color: white;
}
.bottom_fade-enter-active,
.bottom_fade-leave-active {
  transition: all 0.1s ease;
}
.bottom_fade-enter,
.bottom_fade-leave-to {
  opacity: 0;
  transform: translateY(30px);
}
.fixed_bottom {
  z-index: 999;
  position: fixed;
  bottom: 0;
  right: 0;
  max-width: 100%;
  padding: 23px;
  background-color: #f5f5f5;
  box-shadow: rgb(158, 158, 158) 1px 3px 17px 0px;
}
.schemeArea {
  display: flex;
  border: 2px;
  border-style: solid;
  border-radius: 10px;
  border-color: #43ae46;
  padding: 15px 15px 5px 15px;
  flex-direction: column;
  align-items: center;
}
.schemeTable {
  width: 540px;
  margin-top: 10px;
  th,
  td {
    text-align: center !important;
  }
  .table.datatable tbody tr > td:first-child {
    padding-left: 10px;
    padding-top: 10px;
  }
}
.payPriodError {
  border-style: solid;
  border-width: 1px;
  border-color: #de4054;
  border-radius: 10px;
}
</style>
